import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
var Root = styled.div.withConfig({
  displayName: "DrawerBody__Root",
  componentId: "iiww5v-0"
})(["flex:1;position:relative;overflow-y:auto;outline:none;"]);
var Overlay = styled.div.withConfig({
  displayName: "DrawerBody__Overlay",
  componentId: "iiww5v-1"
})(["position:-webkit-sticky;position:sticky;right:var(--size-spacing-05);left:var(--size-spacing-05);bottom:0;height:40px;margin-top:-40px;background:linear-gradient(180deg,transparent 0%,var(--color-white) 100%);"]);
var Content = styled.div.withConfig({
  displayName: "DrawerBody__Content",
  componentId: "iiww5v-2"
})(["padding:var(--size-spacing-05);"]);

var _ref =
/*#__PURE__*/
React.createElement(Overlay, null);

var DrawerBody = function DrawerBody(_ref2) {
  var children = _ref2.children;
  return (
    /*#__PURE__*/
    React.createElement(Root, {
      tabIndex: 0
    },
    /*#__PURE__*/
    React.createElement(Content, null, children), _ref)
  );
};

DrawerBody.defaultProps = {
  children: undefined
};
process.env.NODE_ENV !== "production" ? DrawerBody.propTypes = {
  /**
   * Drawer content
   */
  children: PropTypes.node
} : void 0;
export default DrawerBody;